import { soFetch } from 'so-fetch';
import * as constants from './tags-constants';

export function getTags(id) {
  return soFetch(`/proxy/company/${id}/tags`, {
    actionType: constants.GET_TAGS,
    responseBinding: 'payload',
  });
}

export function deleteTag(payload) {
  return dispatch => {
    dispatch({ type: constants.DELETING_TAG });
    return fetch('/proxy/tags', {
      method: 'delete',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
    .then(res => {
      if (res.status !== 200) throw new Error(res.status);
      return dispatch({ type: 'DELETED_TAG', payload: { tagName: payload.tagName, tadId: payload.tagId } });
    });
  };
}



// WEBPACK FOOTER //
// ./src/app/stores/tags/tags-actions.js